import ExpandLeftIcon from "@diligentcorp/atlas-react-icons/ExpandLeft.js";
import ExpandRightIcon from "@diligentcorp/atlas-react-icons/ExpandRight.js";
import { applyTokens } from "../../../utilities/applyTokens.js";
import { createAtlasTabScrollButton } from "../utils/createAtlasTabScrollButton.js";
const getTabTokens = (tokens) => {
    return {
        tabs: tokens.component.tabs,
        tab: tokens.component.tabs.tab,
        semantic: tokens.semantic,
    };
};
const tabs = (tokens) => {
    const { tabs, tab, semantic } = getTabTokens(tokens);
    return {
        MuiTabs: {
            defaultProps: {
                ScrollButtonComponent: createAtlasTabScrollButton({
                    LeftIcon: ExpandLeftIcon,
                    RightIcon: ExpandRightIcon,
                }, tokens),
            },
            styleOverrides: {
                root: {
                    minHeight: tabs.height.value,
                    overflow: "visible",
                    borderBottom: `${tabs.divider.borderBottomWidth.value} solid ${tabs.divider.borderColor.value}`,
                    "&.atlas-size-large": {
                        minHeight: tabs.large.height.value,
                        "& .MuiTab-root": Object.assign(Object.assign({}, applyTokens(tabs.large.tab)), { minHeight: tabs.large.height.value }),
                    },
                },
                scroller: {
                    "&:focus-visible": {
                        outline: "none",
                        boxShadow: semantic.shadow.focusInset.value.stringValue,
                    },
                },
                scrollableX: {
                    "& .MuiTabs-flexContainer": {
                        marginBottom: `-${semantic.borderWidth.thin.value}`,
                    },
                },
                fixed: {
                    "&.MuiTabs-scroller": {
                        "&&&": {
                            // MUI sets overflow:hidden inline :(
                            // https://github.com/mui/material-ui/blob/32c33b5dfa835cc0b29a219e6d915b178ab15b8d/packages/mui-material/src/Tabs/Tabs.js#L305
                            overflow: "visible !important",
                        },
                    },
                    ".MuiTabs-flexContainer": {
                        marginBottom: `-${semantic.borderWidth.thin.value}`,
                    },
                },
                indicator: {
                    height: tabs.indicator.height.value,
                    backgroundColor: tabs.indicator.backgroundColor.value,
                    // the indicator is absolutely positioned by MUI, so we'll clip it from the sides to match Atlas
                    clipPath: `inset(0 ${tab.paddingHorizontal.value} 0 ${tab.paddingHorizontal.value})`,
                    bottom: `-${semantic.borderWidth.thin.value}`,
                },
            },
        },
        MuiTab: {
            defaultProps: {
                iconPosition: "start",
            },
            styleOverrides: {
                root: Object.assign(Object.assign({}, applyTokens(tab)), { minWidth: "unset", minHeight: tabs.height.value, padding: `0 ${tab.paddingHorizontal.value}`, "&:hover": Object.assign(Object.assign({}, applyTokens(tab.hover)), { "& > svg ": Object.assign({}, applyTokens(tab.hover.icon)) }), "&:active": Object.assign(Object.assign({}, applyTokens(tab.active)), { "& > svg ": Object.assign({}, applyTokens(tab.active.icon)) }), "&:focus": Object.assign(Object.assign({}, applyTokens(tab.active)), { boxShadow: semantic.shadow.focusInset.value.stringValue, position: "relative", zIndex: 1, "& > svg ": Object.assign({}, applyTokens(tab.focus.icon)) }), "& > svg ": {
                        height: semantic.iconSize.lg.value,
                        width: semantic.iconSize.lg.value,
                        color: tab.icon.color.value,
                    }, "& > .MuiTab-iconWrapper": {
                        marginRight: 0,
                    }, "&.Mui-selected:not(.Mui-disabled)": {
                        color: tab.selected.color.value,
                        ":&hover": {
                            color: tab.selected.hover.color.value,
                        },
                        ":&active": {
                            color: tab.selected.active.color.value,
                        },
                        "& > svg ": {
                            color: tab.selected.icon.color.value,
                        },
                    }, "&.Mui-disabled": {
                        color: tab.disabled.color.value,
                        "& > svg ": {
                            color: tab.disabled.icon.color.value,
                        },
                    } }),
            },
        },
    };
};
export default tabs;
//# sourceMappingURL=tabs.js.map